module.exports = __webpack_public_path__ + "img/dku.00106.5a1ff1e2.png";